import ReactDom from 'react-dom';
import React from 'react';
import ConfirmDelete from './confirm_delete.js';
import { initOembedContainers } from '../Shared/remote_embed.js';
import { getOrCreateHandle } from 'Shared/prosemirror/answers.js';

initOembedContainers();

onDomReady(function() {
   const questionid = App.questionid;
   let allCommentsLoaded = false;
   let activeFilterTab = $E('.filter-option-active');
   let currentSort = (activeFilterTab && activeFilterTab.getAttribute('data-filter')) || 'Default'; // Matches Question::SORT_DEFAULT
   var handle;
   var answerFormManager;

   const elementAbovePM = document.querySelector('.answer-input-title');

   if (elementAbovePM) {
      const showPMOptions = {
         root: null,
         rootMargin: '0px',
         threshold: 0,
      };

      function showProseMirror(entries, observer) {
         const isInView = entries[0].target === elementAbovePM && entries[0].isIntersecting;

         if (isInView) {
            getEditor();
         }
      }

      const observer = new IntersectionObserver(showProseMirror, showPMOptions);
      observer.observe(elementAbovePM);
   }

   /**
    * Get an attribute of the provided element, or it's nearest parent that has
    * a value; null otherwise.
    */
   function getParentAttribute(el, attr) {
      var val = el.get(attr);
      if (val === null) {
         el = el.getParent('[' + attr + ']');
         val = el && el.get(attr);
      }
      return val;
   }

   function animateElement(el, action) {
      var size;

      if (action === 'show') {
         size = el.getChildren()[0].getSize().y;
      } else if (action === 'hide') {
         size = '0px';
      }

      TweenMax.to(el, 0.4, { height: size });
   }

   function rotateElement(el, action) {
      var degrees;

      if (action === 'show') {
         degrees = -180;
      } else if (action === 'hide') {
         degrees = 0;
      }

      TweenMax.to(el, 0.4, { rotation: degrees, ease: Expo.easeInOut });
   }

   function togglePostTranslation(el, action) {
      el.hide();
      var post = el.getParent('.js-post');
      var arrowIcon = post.getElement('.js-translation-info .fa');
      var container = post.getElement('.js-translated-post-container');

      if (action === 'show') {
         post.getElement('.js-hide-translation').show('inline');
      } else if (action === 'hide') {
         post.getElement('.js-show-translation').show();
      }

      animateElement(container, action);
      rotateElement(arrowIcon, action);
   }

   function toggleCommentTranslation(el, action) {
      el.hide();

      var comments = el.getParent('.js-comments');
      var arrowIcon = comments.getElement('.js-translation-info .fa');
      var translations = comments.getElements('.js-translated-comment');

      if (action === 'show') {
         comments.getElement('.js-hide-translated-comments').show('inline');
         translations.show();
      } else if (action === 'hide') {
         comments.getElement('.js-show-translated-comments').show('inline');
         translations.hide();
      }

      rotateElement(arrowIcon, action);
   }

   function showHiddenComments(moreElement) {
      const postid = moreElement.get('data-postid');
      const showComments = () => {
         // All the comments-more links get replaced in replaceAnswersAndQuestionHtml,
         // so we need to re-find the button.
         moreElement = $('comments-more-' + postid);
         moreElement.getSiblings('.js-comments-extra').removeClass('hidden');
         moreElement.hide();
      };
      if (!allCommentsLoaded) {
         replaceAnswersAndQuestionHtml().then(showComments);
      } else {
         showComments();
      }
   }

   // Copied from utils.js onHashFragmentElement()
   function watchHashChange(handler) {
      function callHandlerWithElement() {
         if (window.location.hash) {
            const id = window.location.hash.substr(1);
            const element = $(id);

            if (element) {
               handler(element);
            } else if (!allCommentsLoaded && id.startsWith('comment')) {
               // Load extra comments first.
               replaceAnswersAndQuestionHtml().then(() => {
                  const element = $(id);
                  if (element) {
                     handler(element);
                  }
               });
            }
         }
      }

      onDomReady(callHandlerWithElement);
      window.addEventListener('hashchange', callHandlerWithElement);
   }

   // If the url hash refers to a hidden comment, show all comments
   watchHashChange(function(comment) {
      if (!comment.visible()) {
         var more = comment.getSiblings('.js-comments-more');

         if (more[0]) {
            showHiddenComments(more[0]);

            // Wait until the page loads so that the scroll position can be
            // calculated.
            onLoad(function() {
               comment.jumpTo({
                  offset: 0,
                  duration: 0,
               });
            });
         }
      }
   });

   function updateAnswerText() {
      $('qaText').set('value', handle.value);
   }

   when($('answer-form'), function(answerForm) {
      answerFormManager = new FormManager(answerForm);
      var answerTextArea = $('qaText');

      function postAsComment() {
         var firstPost = $E('.js-user-first-post');
         if (firstPost) {
            var postid = firstPost.get('data-postid');
            var userid = firstPost.get('data-userid');
            var form = firstPost.getElement('.js-comment-form');

            firstPost.getElement('.js-add-comment').hide();
            initializeCommentForm(form);
            form.show();
            var textarea = form.getElement('textarea');
            textarea.set('value', handle.value);

            handle.clear();
            textarea.focus();
         }
      }

      answerFormManager.setValidator('qaText', function() {
         var text = handle.text;
         text = text.replace(/^\s+/g, ''); // strip leading
         text = text.replace(/\s+$/g, ''); // strip trailing

         if (text.length === 0) {
            return _js('Please answer the question.');
         }

         if (text.length < App.minAnswerLength) {
            return answerFormManager.requiredError(
               _js(
                  'Body must be at least %1 characters, you entered %2',
                  App.minAnswerLength,
                  text.length
               )
            );
         }

         text.replace('\r\n', '\n');
         text.replace('\r', '\n');
         var parts = text.split('\n');
         if (parts.length > App.maxAnswerLines) {
            return _js(
               'This post has more than %1 lines. You should shorten it.',
               App.maxAnswerLines
            );
         }
      });

      answerFormManager.addSubmitHandler(function() {
         updateAnswerText();

         Auth.required({
            message: _js('Log in to answer a question.'),
            onAuthorize: function() {
               var buttons = {};

               if (answerForm.hasClass('js-user-answering-only-question')) {
                  buttons[_js('Post as comment')] = postAsComment;
                  buttons[_js('Update question')] = function() {
                     if (!window.iFixit_clickedSubmit) {
                        window.iFixit_clickedSubmit = true;
                        $('updateText').set('value', handle.value);
                        $('updateForm').submit();
                     }
                  };
                  buttons[_js('Answer anyway')] = function() {
                     if (!window.iFixit_clickedSubmit) {
                        window.iFixit_clickedSubmit = true;
                        answerFormManager.submitNow();
                     }
                  };
                  buttons[_js('Cancel')] = function() {};

                  Modal.open({
                     type: 'message',
                     message: htmlEncode(
                        _js(
                           'You are writing an answer to your own question. %1 If you wish to add clarifying information or update your question, please do so with a comment, instead of an answer.'
                        )
                     ).replace('%1', '<br><br>'),
                     buttons: buttons,
                  });
               } else if (answerForm.hasClass('js-user-answering-again')) {
                  buttons[_js('Post as comment')] = postAsComment;
                  buttons[_js('Update answer')] = function() {
                     window.iFixit_clickedSubmit = true;
                     $('updateText').set('value', answerTextArea.get('value'));
                     $('updateForm').submit();
                  };
                  buttons[_js('Answer anyway')] = function() {
                     if (!window.iFixit_clickedSubmit) {
                        window.iFixit_clickedSubmit = true;
                        answerFormManager.submitNow();
                     }
                  };
                  buttons[_js('Cancel')] = function() {};

                  Modal.open({
                     type: 'message',
                     message: htmlEncode(
                        _js(
                           '%1You have already answered this.%2 If at all possible, update your answer or add a comment instead of posting a new answer.'
                        )
                     )
                        .replace('%1', '<strong>')
                        .replace('%2', '</strong><br><br>'),
                     buttons: buttons,
                  });
               } else {
                  if (!window.iFixit_clickedSubmit) {
                     trackEvent('Answers', 'Click', 'Submit Answer');
                     window.iFixit_clickedSubmit = true;
                     answerFormManager.submitNow();
                  }
               }
            },
         });
      });

      var answerAutoPreview = new AutoPreview(
         'answer-form',
         'answerPreviewContainer',
         'getPreview',
         {},
         {
            class: 'qaText',
            styles: {
               'border-top': 'none',
            },
         }
      );
   });

   $('content').addEvents({
      'click:relay(.js-preview-answer)': function(ev, el) {
         ev.stop();
         updateAnswerText();
         var formManager = $('answer-form').retrieve('FormManager:formManager');

         formManager.validate(function() {
            $('answerPreviewContainer').show();
            window.scrollTo(0, $('answerPreviewContainer').getPosition().y);
         });
      },
      'click:relay(.js-toggle-selected)': function(ev, el) {
         var isSelected = el.hasClass('selected');
         $$('.js-toggle-target').removeClass('toggle-open');
         $$('.js-toggle-selected').removeClass('selected');

         var target = el.getParent().getElement('.js-toggle-target');
         if (isSelected) {
            target.removeClass('toggle-open');
            el.removeClass('selected');
         } else {
            target.addClass('toggle-open');
            el.addClass('selected');
         }
      },
      'click:relay(.js-filter-option)': function(ev, el) {
         ev.stop();
         currentSort = el.get('data-filter');
         var listElement = el.getParent();
         var toggleButton = listElement.getParent().getElement('.js-toggle-selected');

         replaceAnswersAndQuestionHtml().then(function() {
            el.addClass('filter-option-active');
            listElement.removeClass('toggle-open');
            toggleButton.removeClass('selected');
         });
      },
      'click:relay(.js-score-history)': function(ev, el) {
         var postid = getParentAttribute(el, 'data-postid');
         Auth.required({
            message: _js('Log in to view this posts voting history.'),
            onAuthorize: function() {
               new Request.AjaxIO('getVotesOnPost', {
                  onSuccess: function(response) {
                     if (response.error) {
                        if (response.error == 'no_display') {
                           return false;
                        } else {
                           return false;
                        }
                     } else {
                        var element = new Element('div');
                        element.set('html', response.html);
                        Modal.open({
                           type: 'element',
                           element: element,
                        });
                     }
                  },
               }).send(postid);
            },
         });
      },
      'click:relay(.js-add-comment)': function(ev, el) {
         var parent = el.getParent('.js-post');
         el.hide();
         var form = el.getNext('.js-comment-form');

         initializeCommentForm(form);
         form.show();
         form.getElement('textarea').focus();
      },
      'click:relay(.js-button-vote)': function(ev, el) {
         var postid = getParentAttribute(el, 'data-postid');
         var voteDirection = el.get('data-voteDirection');
         var currentVoteDirection = getParentAttribute(el, 'data-currentVote');
         postVoteAction(el, voteDirection, currentVoteDirection, postid);
      },
      'click:relay(.js-cancel-comment)': function(ev, el) {
         ev.stop();
         el.getParent('.js-comment-form').hide();
         el.getParent('.js-add-comment-container')
            .getElement('.js-add-comment')
            .show();
      },
      'click:relay(.js-cancel-edit-comment)': function(ev, el) {
         ev.stop();
         var parent = el.getParent('.js-comment');
         var editContainer = parent.getElement('.js-comment-edit-container');
         var commentText = parent.getElement('.js-comment-text');
         var commentMeta = parent.getElement('.comment-meta');
         editContainer.hide();
         commentText.show();
         commentMeta.show();
      },
      'click:relay(.js-comment-edit)': function(ev, el) {
         ev.stop();

         Auth.required({
            onAuthorize: function() {
               var parent = el.getParent('.js-comment');
               var editContainer = parent.getElement('.js-comment-edit-container');
               var commentText = parent.getElement('.js-comment-text');
               var commentMeta = parent.getElement('.comment-meta');

               commentText.hide();
               commentMeta.hide();
               editContainer.show();

               var submitHandler = editContainer.getElement('.js-submit-comment-edit');
               if (!submitHandler.hasClass('submit-handler')) {
                  submitHandler.addClass('submit-handler').addEvent('click', function(event) {
                     var commentid = event.target.get('data-commentid');
                     var text = editContainer.getElement('textarea').value;
                     new Request.AjaxIO('editComment', {
                        onSuccess: function(res) {
                           editContainer.hide();
                           commentText.set('html', res.text);
                           commentText.show();
                           commentMeta.show();
                        },
                     }).send(commentid, text);
                  });
               }
            },
         });
      },
      'click:relay(.js-comment-reply)': function(ev, el) {
         ev.stop();
         const author = el.get('data-author');
         const post = el.getParent('.js-post');

         post.getElement('.js-add-comment').hide();
         const commentForm = post.getElement('.js-comment-form');

         initializeCommentForm(commentForm);
         commentForm
            .show()
            .getElement('textarea')
            .set('value', '@' + author + ' ')
            .focus();
      },
      'click:relay(.js-comments-more)': function(ev, el) {
         showHiddenComments(el);
      },
      'click:relay(.js-show-translated-comments)': function(ev, el) {
         toggleCommentTranslation(el, 'show');
      },
      'click:relay(.js-hide-translated-comments)': function(ev, el) {
         toggleCommentTranslation(el, 'hide');
      },
      'click:relay(.js-watch-post)': function(ev, el) {
         var isWatching = el.get('data-isWatching');
         var shouldWatch = isWatching == 'true' ? 'off' : 'on';
         var parent = el.getParent('.js-post');
         var postid = parent.get('data-postid');

         function createWatchPromise(watchType) {
            var email = !App._tempEmail ? null : App._tempEmail;
            return new Request.AjaxIO(watchType, {
               onSuccess: subscribeResponseHandler,
            }).send(shouldWatch, 'post', postid, email);
         }

         function subscribeResponseHandler(response) {
            if (!response || response === 1) {
               var isLoggedIn = Auth.isLoggedIn();

               if (shouldWatch === 'on' && isLoggedIn) {
                  // if the user is logged in,
                  // upvote the question
                  var voteEl = parent.getElement('.js-button-vote.js-vote-yes');
                  postVoteAction(voteEl, 'up', 'none', postid);
               }

               $$('.js-not-watching').setStyle(
                  'display',
                  shouldWatch === 'on' ? 'none' : 'inline-block'
               );
               $$('.js-watching').setStyle(
                  'display',
                  shouldWatch === 'on' ? 'inline-block' : 'none'
               );

               trackEvent('Question Subscribe', shouldWatch === 'on' ? 'Subscribe' : 'Unsubscribe');
            }
         }

         if (!Auth.isLoggedIn() && !App._tempEmail) {
            Modal.open({
               type: 'module',
               name: 'Watch',
               boxClass: 'watchModal',
            });
            Modal.addEvent('afterLogIn', function() {
               createWatchPromise('watch');
               window.location.reload();
            });
            Modal.addEvent('emailSubmitted', function() {
               subscribeResponseHandler();
            });
         } else if (App._tempEmail) {
            LoadingIndicator.withPromise(createWatchPromise('watchByEmail'));
         } else {
            LoadingIndicator.withPromise(createWatchPromise('watch'), {
               failureMessage: _js('Invalid Account Email'),
            });
         }
      },
      'click:relay(.js-show-translation)': function(ev, el) {
         togglePostTranslation(el, 'show');
      },
      'click:relay(.js-hide-translation)': function(ev, el) {
         togglePostTranslation(el, 'hide');
      },
      'click:relay(.js-answer-question)': function(ev, el) {
         getEditor();

         var answerForm = $('answer-form');
         var answerFormPosition = answerForm.getPosition();
         window.scrollTo(0, answerFormPosition.y);

         document.getElementById('answerEditor').focus();
      },
      'click:relay(.js-view-accepted)': function(ev, el) {
         var acceptedAnswer = $$('.post-accepted')[0];
         var answerPosition = window.scrollTo(0, acceptedAnswer.getPosition().y);
      },
      'click:relay(.js-action-delete)': function(ev, el) {
         const docid = el.get('data-docid');
         const doctype = el.get('data-doctype');

         const modalContent = document.createElement('div');
         modalContent.setAttribute('id', 'deleteCommentModule');

         Modal.open({
            type: 'element',
            element: modalContent,
         });

         ReactDom.render(
            <ConfirmDelete docid={docid} doctype={doctype} />,
            document.getElementById('deleteCommentModule')
         );
      },
   });

   // Don't show this element till it's tied to `click` event.
   $$('.js-show-translation').show('inline');
   $$('.js-show-translated-comments').show('inline');

   function getEditor() {
      var pm = document.getElementById('answerEditor');
      handle = getOrCreateHandle(pm, '#answer-form');
      answerFormManager.required(handle.el);
   }

   function initializeCommentForm(el) {
      var formManager = new FormManager(el);
      var textarea = el.getElement('textarea');
      var chars = el.getElement('.js-max-characters');
      var charCount = chars.getElement('.js-current-characters');
      var maxCharacters = parseInt(chars.getProperty('data-maximum'), 10);
      var minCharacters = parseInt(chars.getProperty('data-minimum'), 10);

      function updateTextStatus() {
         var length = textarea.get('value').trim().length;
         charCount.set('text', length);

         if (length < minCharacters || length > maxCharacters) {
            chars.addClass('invalid');
         } else if (length >= minCharacters && length <= maxCharacters) {
            chars.removeClass('invalid');
         }
      }

      textarea.addEvents({
         keyup: function(ev) {
            updateTextStatus();

            // Autoresize comment textarea
            textarea.set('rows', textarea.value.length / 60 + 2);
         },
         keydown: function(ev) {
            if (ev.key == 'space' || ev.key == 'backspace') {
               updateTextStatus();
            }
         },
      });

      formManager.setValidator(textarea, function() {
         var text = textarea.value
            .trim()
            .replace(/\r\n?/, '\n')
            .replace(/ +/, ' ');

         if (text.length <= 0) {
            return _js('You cannot submit an empty comment!');
         }

         if (text.length > maxCharacters) {
            /* Translators: %1 -> max characters; %2 -> character length; */
            return _js(
               'Your comment is too long. Please keep it under %1 characters. It is currently %2 characters.'
            )
               .replace('%1', maxCharacters)
               .replace('%2', text.length);
         } else if (text.length < minCharacters) {
            /* Translators: %1 -> min characters; %2 -> character length; */
            return _js(
               'Your comment is too short. Please write something over %1 characters. It is currently %2 characters.'
            )
               .replace('%1', minCharacters)
               .replace('%2', text.length);
         }

         var parts = text.split('\n');
         if (parts.length >= 1001) {
            /* Translators: %1 -> number of lines; */
            return _js('This comment has %1 lines. You should shorten it.').replace(
               '%1',
               parts.length - 1
            );
         }
      });

      formManager.addSubmitHandler(function() {
         Auth.required({
            message: _js('Log in to comment on a question.'),
            onAuthorize: function() {
               if (!window.iFixit_clickedSubmit) {
                  window.iFixit_clickedSubmit = true;
                  formManager.submitNow();
               }
            },
         });
      });
   }

   function replaceAnswersAndQuestionHtml() {
      const getAnswersPromise = new Request.AjaxIO('getAnswers', {
         onSuccess: function(response) {
            if (response.error) {
               Modal.alert(response.error);
               return false;
            }

            let deviceContainer = $E('.question-device-container');
            if (deviceContainer) {
               deviceContainer.dispose();
            }
            $$('.js-question-container').set('html', response.question);
            $$('.js-answers-list').set('html', response.answers);
            $$('.js-filter-option').removeClass('filter-option-active');

            if (deviceContainer) {
               // We don't rerender the device frame module, so we have to re-add it.
               // The template thinks that it has no device, so we have to drop the
               // extra class it adds.
               $E('.js-post-question')
                  .removeClass('post-no-device')
                  .grab(deviceContainer, 'top');
            }

            $$('.js-show-translation').show('inline');
            $$('.js-show-translated-comments').show('inline');
            allCommentsLoaded = true;
            CSRF.recheckAll();
         },
      }).send({ questionid: questionid, sort: currentSort });

      LoadingIndicator.withPromise(getAnswersPromise, {
         pendingMessage: _js('Loading answers') + '...',
         hideSuccessMessage: true,
      });
      return getAnswersPromise;
   }

   function postVoteAction(el, direction, curDirection, postid) {
      Auth.required({
         message: _js('Log in to vote.'),
         onAuthorize: function() {
            if (direction == 'up') {
               direction = 1;
            } else if (direction == 'down') {
               direction = -1;
            } else if (direction == 'undo') {
               direction = curDirection == 'up' ? 1 : -1;
            }

            if (curDirection == 'up') {
               curDirection = 1;
            } else if (curDirection == 'down') {
               curDirection = -1;
            }

            new Request.AjaxIO('ajaxVote', {
               onSuccess: function(response) {
                  if (response.error) {
                     Tooltip.instance(el, response.error, {
                        side: 'top',
                     }).show();
                     return;
                  }

                  var voteContainer = el.getParent('.js-vote-container');
                  var scoreEl = voteContainer.getElements('.js-post-score')[0];

                  scoreEl.set('text', response.score);

                  var yesNoEl = voteContainer.getElements('.js-yes-no-buttons')[0];
                  var votedEl = voteContainer.getElements('.js-buttons-voted')[0];

                  // if the direction is false, the vote was un-done
                  if (response.direction === false || direction == curDirection) {
                     yesNoEl.show();
                     votedEl.hide();
                     voteContainer.set('data-currentVote', 'none');
                  } else {
                     yesNoEl.hide();
                     votedEl.show();

                     voteContainer.set(
                        'data-currentVote',
                        response.direction == -1 ? 'down' : 'up'
                     );

                     voteContainer
                        .getElements('.js-button-voted')[0]
                        .set(
                           'class',
                           'voted-action js-button-voted ' +
                              (response.direction == -1 ? 'voted-no' : 'voted-yes')
                        )
                        .set(
                           'html',
                           response.direction == -1
                              ? '<i class="fa fa-times"></i> ' + _js('Voted No')
                              : '<i class="fa fa-check"></i> ' + _js('Voted Yes')
                        );
                  }
               },
            }).send(postid, direction, curDirection);
         },
      });
   }
});
